<template>
  <div>
    <div class="main-init" id="dragInit" v-drag v-show="isShouQi">
      <div class="main-search" :style="{'width':(dialogWidth===40?'':'1210px')}" v-if="vis">
        <div class="expend-box center" @click="extension(dialogWidth)">
          <svg v-if="dialogWidth===40" t="1638414758019" class="icon" viewBox="0 0 1024 1024" version="1.1"
               xmlns="http://www.w3.org/2000/svg" p-id="2524" width="16" height="16">
            <path
                d="M849 509.3L456.27 904.74a32 32 0 0 0 45.41 45.1L917 531.7a32 32 0 0 0-0.16-45.25L501.53 74a32 32 0 1 0-45.1 45.41z"
                p-id="2525" fill="#ffffff"></path>
            <path
                d="M499.78 509.3L107.05 904.74a32 32 0 0 0 45.41 45.1L567.74 531.7a32 32 0 0 0-0.16-45.25L152.31 74a32 32 0 0 0-45.1 45.41z"
                p-id="2526" fill="#ffffff"></path>
          </svg>
          <svg v-else t="1638414828487" class="icon" viewBox="0 0 1024 1024" version="1.1"
               xmlns="http://www.w3.org/2000/svg" p-id="3348" width="16" height="16">
            <path
                d="M176 513.7l392.73-395.44a32 32 0 0 0-45.41-45.1L108 491.3a32 32 0 0 0 0.16 45.25L523.48 949a32 32 0 1 0 45.1-45.41z"
                p-id="3349" fill="#ffffff"></path>
            <path
                d="M525.23 513.7L918 118.26a32 32 0 1 0-45.41-45.1L457.27 491.3a32 32 0 0 0 0.16 45.25L872.7 949a32 32 0 0 0 45.1-45.41z"
                p-id="3350" fill="#ffffff"></path>
          </svg>
        </div>
        <div class="header">
          <div style="">
            {{ $t('satellite.DataRetrieval') }}
          </div>
          <div style="width: 60px;" class="center">
            <svg @click="isShouQi=false" t="1654503901810" class="icon" viewBox="0 0 1024 1024" version="1.1"
                 xmlns="http://www.w3.org/2000/svg" p-id="11438" width="32" height="32">
              <path
                  d="M512 113.777778a398.222222 398.222222 0 1 1 0 796.444444A398.222222 398.222222 0 0 1 512 113.777778z m0 56.888889a341.333333 341.333333 0 1 0 0 682.666666A341.333333 341.333333 0 0 0 512 170.666667z"
                  p-id="11439" fill="#ffffff"></path>
              <path
                  d="M341.333333 483.555556m28.444445 0l284.444444 0q28.444444 0 28.444445 28.444444l0 0q0 28.444444-28.444445 28.444444l-284.444444 0q-28.444444 0-28.444445-28.444444l0 0q0-28.444444 28.444445-28.444444Z"
                  p-id="11440" fill="#ffffff"></path>
            </svg>
            <svg @click="closeVis" t="1638414880368" class="icon" viewBox="0 0 1024 1024" version="1.1"
                 xmlns="http://www.w3.org/2000/svg" p-id="4385" width="32" height="32">
              <path
                  d="M85.333333 512C85.333333 276.352 276.309333 85.333333 512 85.333333c235.648 0 426.666667 190.976 426.666667 426.666667 0 235.648-190.976 426.666667-426.666667 426.666667-235.648 0-426.666667-190.976-426.666667-426.666667z m426.666667-30.165333l-105.685333-105.706667a21.269333 21.269333 0 0 0-30.08 0.106667 21.205333 21.205333 0 0 0-0.106667 30.08L481.834667 512l-105.706667 105.685333a21.269333 21.269333 0 0 0 0.106667 30.08 21.205333 21.205333 0 0 0 30.08 0.106667L512 542.165333l105.685333 105.706667a21.269333 21.269333 0 0 0 30.08-0.106667 21.205333 21.205333 0 0 0 0.106667-30.08L542.165333 512l105.706667-105.685333a21.269333 21.269333 0 0 0-0.106667-30.08 21.205333 21.205333 0 0 0-30.08-0.106667L512 481.834667z"
                  fill="#ffffff" p-id="4386"></path>
            </svg>
          </div>
        </div>
        <div class="sate-info-context">
          <div class="sate-info-table-data">
            <el-table
                @row-click="openDetails"
                @cell-mouse-enter="cellMouseEnter"
                @cell-mouse-leave="cellMouseLeava"
                ref="multipleTable"
                :header-cell-style="header_cell_style"
                :cell-style="cell_style"
                :data="tableList"
                max-height="444"
                tooltip-effect="dark"
                @selection-change="handleSelectionChange">
              <el-table-column
                  type="selection"
                  width="55">
              </el-table-column>
              <el-table-column
                  prop="MONGO_ID"
                  :label="$t('Order.thumbnail')"
                  align="center"
                  width="120">
                <template slot-scope="scope">
                  <el-image v-if="scope.row.mediaUrl != null && scope.row.mediaUrl.split('?')[1].length>4"
                            style="width: 30px;height: 30px;"
                            :src="scope.row.mediaUrl"
                  ></el-image>
                  <span v-else>{{ $t('satellite.Nothumbnail') }}</span>
                </template>
              </el-table-column>
              <el-table-column
                  v-if="leftMapShow"
                  prop="datafieID"
                  align="center"
                  :label="$t('satellite.dataidentifier')"
                  show-overflow-tooltip>
              </el-table-column>
              <el-table-column
                  v-if="leftMapShow"
                  prop="lines"
                  align="center"
                  :label="$t('satellite.stripe')"
                  show-overflow-tooltip>
              </el-table-column>
              <el-table-column
                  prop="stoptime"
                  :label="$t('Order.Shootingtime')"
                  align="center"
                  width="200"
                  show-overflow-tooltip>
              </el-table-column>
              <el-table-column
                  prop="cloudcover"
                  :label="$t('satellite.cloudcover')"
                  align="center"
                  width="120"
                  show-overflow-tooltip>
              </el-table-column>
              <el-table-column
                  prop="address"
                  :label="$t('product.Operation')"
                  align="center"
                  width="130"
                  show-overflow-tooltip>
                <template slot-scope="scope">
                  <el-image class="el-button" style="border: 0px;padding: 0px;width: 25px;height: 25px"
                            :src="require('../../../../images/car.png')"
                            @click.stop="addFileToCar([scope.row.datafieID])" type="text" size="small"></el-image>
                  <el-image class="el-button" style="border: 0px;padding: 0px;width: 25px;height: 25px"
                            :src="require('../../../../images/info.png')" @click="baseInfo(scope.row)" type="text"
                            size="small"></el-image>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="sate-info-map">
            <div class="sate-info-map-sate" v-show="leftMapShow">
              <el-image style="width: 300px;height: 200px" :src="selectRowImage">
                <div slot="error" class="image-slot center">
                  {{ $t('satellite.Nothumbnail') }}
                </div>
              </el-image>
            </div>
            <div class="sate-info-map-abridge" v-if="leftMapShow">
              <div id="mapBase" style="width:300px;height:200px"></div>
            </div>
          </div>
        </div>
        <div style="margin: 20px 0 12px 0;padding:0 24px" class="centerS">
          <div class="center">
            <el-button class="bg-btn" size="mini" type="primary" plain @click="addSelectFileToCar()">
              {{ $t('product.AddtoCartinBulk') }}
            </el-button>
            <el-button size="mini" type="primary" @click="allAddShopcar_fuc">{{ $t('product.Addalltoshoppingcart') }}
            </el-button>
            <el-badge :max="99" :value="shopTotal_getter" style="margin-left:8px;z-index: 1000">
              <el-button size="mini" type="primary" @click="gotoShopcar">{{ $t('product.shoppingCar') }}</el-button>
            </el-badge>
          </div>
          <div>
            <el-pagination
                background
                small
                @current-change="tableCurrentChange"
                @size-change="handleSizeChange"
                layout="sizes, prev, pager, next"
                :page-size="10"
                :total="totolCount"
                :pager-count="5"
            >
            </el-pagination>
          </div>
        </div>
      </div>
      <SateBaseInfoMsg ref="sateDETAIL"/>
    </div>
    <div style="width:30px;height:30px;background:white;" class="center eyes" v-show="!isShouQi" @click="initEye">
      <svg t="1654565775841" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
           p-id="5106" width="32" height="32">
        <path
            d="M512 298.666667c-162.133333 0-285.866667 68.266667-375.466667 213.333333 89.6 145.066667 213.333333 213.333333 375.466667 213.333333s285.866667-68.266667 375.466667-213.333333c-89.6-145.066667-213.333333-213.333333-375.466667-213.333333z m0 469.333333c-183.466667 0-328.533333-85.333333-426.666667-256 98.133333-170.666667 243.2-256 426.666667-256s328.533333 85.333333 426.666667 256c-98.133333 170.666667-243.2 256-426.666667 256z m0-170.666667c46.933333 0 85.333333-38.4 85.333333-85.333333s-38.4-85.333333-85.333333-85.333333-85.333333 38.4-85.333333 85.333333 38.4 85.333333 85.333333 85.333333z m0 42.666667c-72.533333 0-128-55.466667-128-128s55.466667-128 128-128 128 55.466667 128 128-55.466667 128-128 128z"
            fill="#444444" p-id="5107"></path>
      </svg>
    </div>
  </div>
</template>

<script>
import L from 'leaflet';
import {tiledMapLayer} from '@supermap/iclient-leaflet';
import {mapGetters} from "vuex";
import {
  addToCar
} from "@/api/satellite/index"
import SateBaseInfoMsg from "./info-msg/SateBaseInfoMsg.vue"

export default {
  components: {
    SateBaseInfoMsg
  },
  props: {
    accuseVisible: Boolean,
    accuseitem: Object,
    productInfo: Object
  },
  data() {
    return {
      isShouQi: true,
      shopTotal: 0,
      checkAll: false,
      vis: false,
      leftMapShow: false,
      dialogWidth: 40,
      tableChangeWidth: 40,
      tableList: null,
      multipleSelection: [],
      pageSize: 1,
      totolCount: null,
      currPage: 1,
      totalPage: 1,
      mapBaseView: null,
      AreaGroup: null,
      selectRowImage: '',
      isEnglish: false
    }
  },
  //自定义指令
  directives: {
    drag: {
      // 指令的定义
      bind: function (el) {
        let oDiv = el;  // 获取当前元素
        oDiv.onmousedown = (e) => {
          console.log('onmousedown')
          // 算出鼠标相对元素的位置
          let disX = e.clientX - oDiv.offsetLeft;
          let disY = e.clientY - oDiv.offsetTop;

          document.onmousemove = (e) => {
            // 用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
            let left = e.clientX - disX;
            let top = e.clientY - disY;

            oDiv.style.left = left + 'px';
            oDiv.style.top = top + 'px';

          };
          document.onmouseup = () => {
            document.onmousemove = null;
            document.onmouseup = null;
          }
        }
      }
    }
  },
  computed: {
    ...mapGetters(['themeStatis', 'shopTotal_getter']),
    header_cell_style() {
      if (this.themeStatis === 'theme1') {
        return {'background-color': 'rgba(27,34,64,1)', 'color': 'white'}
      } else {
        return {'background-color': 'white', 'color': '#707780'}
      }
    },
    cell_style() {
      if (this.themeStatis === 'theme1') {
        return {'background-color': 'rgba(27,34,64,1)', 'color': 'white'}
      } else {
        return {'background-color': 'white', 'color': '#707780'}
      }
    },
  },
  mounted() {
    const language = window.localStorage.getItem('language')
    if (language === 'zh') {
      this.isEnglish = false
    }
    if (language === 'en') {
      this.isEnglish = true
    }
  },
  methods: {
    gotoShopcar() {
      this.$router.push('/shopcar')
    },
    initEye() {
      this.isShouQi = true
      let dragInit = document.getElementById('dragInit')
      dragInit.style.top = '0px'
      dragInit.style.left = '50%'
    },
    shouqi() {
      this.$emit('shouqi')
    },
    closeVis() {
      this.vis = false
      this.$emit('closeVisPanel')
    },
    allAddShopcar_fuc() {
      this.$emit('addAllToShopcar')
    },
    quGowuche() {
      if (this.promisShow(1)) {
        return
      }
      this.$router.push({name: 'shopcar'})
    },
    handleSizeChange(val) {
      this.$emit('changePageSize', val)
    },
    cellMouseLeava(row) {
      this.$emit('rowLeave', row)
    },
    cellMouseEnter(row) {
      this.$emit('rowHover', row)
    },
    initBaseMap() {
      this.mapBaseView = L.map('mapBase', {
        rs: L.CRS.EPSG3857,
        center: [50, 50],
        zoom: 1
      });
      tiledMapLayer('http://139.198.12.108:8090/iserver/services/map-bingmap/rest/maps/Aerial', {noWrap: true}).addTo(this.mapBaseView);
      this.AreaGroup = L.layerGroup().addTo(this.mapBaseView);
    },
    baseInfo(val) {
      this.$refs.sateDETAIL.openIt(val)
    },
    extension(val) {
      if (val === 40) {
        this.dialogWidth = 90;
        this.leftMapShow = true
        this.tableChangeWidth = 90
        this.$nextTick(() => {
          this.initBaseMap()
          this.openDetails(this.tableList[0])
        })

      } else {
        this.dialogWidth = 40;
        this.tableChangeWidth = 40;
        this.leftMapShow = false;
      }
      this.$refs.multipleTable.doLayout()
    },
    closeDialog() {
      this.$emit('close-dialogStatus', true)
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      this.$emit('rowSelect', val)
    },
    openDetails(row) {
      this.selectRowImage = row.mediaUrl
      if(this.AreaGroup){
        this.AreaGroup.clearLayers()
      }
      this.addAllArea(row.location_shape.coordinates[0])
    },
    addAllArea(arrs) {
      let a = []
      arrs.forEach(element => {
        a.push([parseFloat(element[1]), parseFloat(element[0])])
      });
      a.splice(a.length - 1, 1)
      var polygon = L.polygon(a, {color: 'red'});
      this.AreaGroup.addLayer(polygon)
      this.mapBaseView.fitBounds(polygon.getBounds());
    },
    tableCurrentChange(currentPage) {
      this.currPage = currentPage;
      this.$emit('setCurrentChange', this.currPage);
    },
    openVis() {
      this.vis = true
    },
    CloseVis() {
      this.vis = false
    },
    async addFileToCar(fileIdArr) {
      if (this.promisShow(2)) {
        return
      }
      if (fileIdArr && fileIdArr.length === 0) {
        this.$message("请选择要加入的数据");
        return
      }
      let param = {
        "carType": 0,
        "fileIdList": fileIdArr,
        "productId": this.productInfo.pkid,
        "productLevel": this.productInfo.productLevel,
        "productName": this.productInfo.productName,
        "satelliteId": this.productInfo.satelliteId,
        "sensorId": this.productInfo.sensorId
      }
      let {data, code} = await addToCar(param)
      if (code === '000000') {
        this.$message({
          message: this.isEnglish ? 'Added to shopping cart successfully' : '加入购物车成功',
          type: 'success'
        })
        this.$store.dispatch('getShopTotal')
      } else {
        this.$message({
          message: this.isEnglish ? 'Failed to add to cart' : '加入购物车失败',
          type: 'error'
        })
      }
      console.log(data);
    },
    addSelectFileToCar() {
      if (this.promisShow(2)) {
        return
      }
      let fileIdArr = []
      this.multipleSelection.forEach(item => {
        console.log(item)
        fileIdArr.push(item.datafieID)
      })
      this.addFileToCar(fileIdArr)
    }
  },
  watch: {
    accuseitem(newValue) {
      this.accuseitem = newValue;
      this.tableList = newValue.list;
      this.pageSize = Number(newValue.pageSize);
      this.totolCount = Number(newValue.totalCount);
      this.totolPage = Number(newValue.totalPage);
      this.currPage = Number(newValue.currPage);
    }
  }

}
</script>

<style lang="scss" scoped>
.main-init {
  position: absolute;
  left: 50%;
  top: 0;
  transform: translate(calc(-50% - 623px), 0);
  z-index: 1000;
}

.eyes {
  position: absolute;
  left: 50%;
  border-radius: 5px;
  transform: translate(calc(-50% - 603px), 0);
  bottom: 6px;
  z-index: 1000;
}

.main-search {
  // background-color: rgba(27,34,64,1);
  @include sitellite_bg_v4_color();
  position: absolute;
  left: 12px;
  top: 24px;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  /deep/ .el-table__row{
    &:hover{
      >td{
        background-color: #0269ff1f !important;
      }
    }
  }

  .expend-box {
    position: absolute;
    right: -15px;
    top: 50%;
    width: 15px;
    height: 40px;
    transform: translate(0%, -50%);
    @include sitellite_bg_v5_color();
    cursor: pointer;
    border-top-right-radius: 50px;
    border-bottom-right-radius: 50px;
    z-index: -1;
  }

  .header {
    height: 48px;
    padding: 0 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: rgba(2, 105, 255, 1);
  }
}

.bg-btn {
  @include sitellite_bg_v6_color();
}

/deep/ .el-button--primary.is-plain:focus, .el-button--primary.is-plain:hover {
  color: rgba(2, 105, 255, 0.7);
}

/deep/ .image-slot {
  width: 100%;
  height: 100%;
  background: white;
  color: #c0c4cc;
}

/deep/ .leaflet-right {
  display: none;
}

/deep/ .el-dialog.sateTable {
  float: left;
  margin-left: 3%;
}


/deep/ .sate-info-context {
  display: flex;
  position: relative;
}

/deep/ .sate-info-table-data {
  flex-grow: 65;
  flex-shrink: 65;
  width: 100%;
}

/deep/ .sate-info-map {
  display: flex;
  flex-direction: column;
  flex-grow: 35;
  flex-shrink: 35;
}

/deep/ .sate-info-map-sate {
  flex-grow: 50;
  flex-shrink: 50;
  padding: 10px;

}

/deep/ .sate-info-map-abridge {
  flex-grow: 50;
  flex-shrink: 50;
  padding: 10px;

}


/deep/ .el-dialog__header {
  background: rgba(2, 105, 255, 1);
  padding: 30px;
}

/deep/ .el-table__empty-block {
  @include sitellite_bg_v4_color();

  span {
    @include co_white_to_black();
  }
}

/*
.el-dialog {
  position: relative;
  margin: 0 auto 50px;
  border-radius: 2px;
  //box-shadow: 0 1px 3px rgb(0 0 0 / 30%);
  box-sizing: border-box;
  width: 100%;//动态修改这个参数
  float: left;
}

.el-dialog__headerbtn {
  position: absolute;
  top: 20px;
  right: 20px;
  padding: 0;
  background: 0 0;
  border: none;
  outline: 0;
  cursor: pointer;
  font-size: 16px;
  visibility: hidden;
}*/

</style>